export const ReceivingInspectionPage = () => {
  return <>ReceivingInspectionPage</>;
};
